import axios from 'axios'
import { ADMIN_API_URL } from 'const'

const BASE_URL = `${ADMIN_API_URL}/animated_videos`

export const testOutline = async (
  sourceId,
  {
    animationType,
    startS,
    endS,
    animationContext,
    style,
    promptVariant,
    notesOverride,
    includeTitle,
  } = {}
) => {
  try {
    const body = { source_id: sourceId }
    if (animationType) body.animation_type = animationType
    if (startS != null) body.start_s = startS
    if (endS != null) body.end_s = endS
    if (animationContext) body.animation_context = animationContext
    if (style) body.style = style
    if (promptVariant) body.prompt_variant = promptVariant
    if (notesOverride != null) body.notes_override = notesOverride
    if (includeTitle != null) body.include_title = includeTitle
    const { data } = await axios.post(`${BASE_URL}/test_outline`, body)
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const testRender = async (
  sourceId,
  { animationType, outline, startS, endS, style } = {}
) => {
  try {
    const body = { source_id: sourceId, outline }
    if (animationType) body.animation_type = animationType
    if (startS != null) body.start_s = startS
    if (endS != null) body.end_s = endS
    if (style) body.style = style
    const { data } = await axios.post(`${BASE_URL}/test_render`, body, {
      // Veo renders take minutes
      timeout: 15 * 60 * 1000,
    })
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}
